import "./Layout.css";

import { useState, useEffect } from "react";

import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "./Footer";

import { Outlet } from "react-router-dom";
import { getStoredUser, getStoredPermissions } from "../utils/auth";

const API_URL = process.env.REACT_APP_API_URL;

function Layout() {

    const [open, setOpen] = useState(false);

    // Desktop sidebar collapse - independent of the mobile
    // open/closed toggle above (that one shows/hides the sidebar
    // entirely on small screens; this one shrinks it to icon-only on
    // desktop to reclaim horizontal space). Persisted so it survives
    // a page refresh, same pattern as the theme color preference.
    const [collapsed, setCollapsed] = useState(() => localStorage.getItem("sidebarCollapsed") === "true");

    useEffect(() => {

        localStorage.setItem("sidebarCollapsed", collapsed ? "true" : "false");

    }, [collapsed]);

    // Seed from localStorage immediately (whatever was set at login),
    // then refresh from the server below - held in state (not just
    // localStorage) so Sidebar actually re-renders once the refresh
    // resolves, instead of only picking up the change on the next
    // full page load.
    const [session, setSession] = useState({
        user: getStoredUser(),
        permissions: getStoredPermissions()
    });

    // Refresh permissions (and user info) from the server on every
    // Layout mount - i.e. on every full page load/refresh while
    // logged in. This is what makes a SuperAdmin's Role Permissions
    // matrix change take effect for other users on their next
    // navigation, rather than only after they log out and back in.
    useEffect(() => {

        const refreshSession = async () => {

            try {

                const res = await fetch(`${API_URL}/portal/me`);

                if (!res.ok) {
                    return; // authFetch already handles 401 -> logout
                }

                const data = await res.json();

                if (data.status) {

                    localStorage.setItem("user", JSON.stringify(data.user));

                    localStorage.setItem("permissions", JSON.stringify(data.permissions || {}));

                    setSession({ user: data.user, permissions: data.permissions || {} });

                }

            } catch (err) {

                console.error("Session refresh failed:", err);

            }

        };

        refreshSession();

    }, []);

    return (

        <div className={`layout ${collapsed ? "sidebar-collapsed" : ""}`}>

            <Sidebar
                open={open}
                setOpen={setOpen}
                user={session.user}
                permissions={session.permissions}
                collapsed={collapsed}
                setCollapsed={setCollapsed}
            />

            <div className="main">

                <Header
                    setOpen={setOpen}
                />

                <div className="content">

                    <Outlet />

                </div>

                <Footer />

            </div>

        </div>

    )

}

export default Layout;